<template>
  <div id="app">
      <keep-alive include="index">
        <router-view>
        </router-view>
      </keep-alive>
  </div>
</template>
<script>
export default {
  data(){
    return{

    }
  },
  created(){
    this.jzsf()
  },
  methods:{
    jzsf(){
      document.addEventListener('touchstart',function (event) {
          if(event.touches.length>1){
            event.preventDefault();
          }
        });
        var lastTouchEnd=0;
        document.addEventListener('touchend',function (event) {
          var now=(new Date()).getTime();
          if(now-lastTouchEnd<=300){
            event.preventDefault();
          }
          lastTouchEnd=now;
        },false);
        document.addEventListener('gesturestart', function (event) {
          event.preventDefault();
        });
    }
  }
}
</script>
<style lang="less">
#app{
  width: 750px;
}
</style>
